import { ActionType, createAction } from 'typesafe-actions';
import { IntlLocale } from '../../../i18n';

export const setLocale = createAction(
  'SET_LOCALE',
  (locale: IntlLocale) => locale
)();

export type LocaleActions = ActionType<typeof setLocale>;
